import * as React from 'react';
import { connect } from 'react-redux';
import { WithStyles, withStyles, Dialog, DialogActions, DialogTitle, IconButton, Checkbox, FormControlLabel} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { HolidayStyle } from './Holiday.style';
import CloseIcon from "@material-ui/icons/Close";
import { DialogTop } from '@components/economy/DialogComponens';
import * as EventActions from "@services/events/event.action"
import { IAiTask, AI_TASK_TYPE } from '@app-types/websocket/event.types';
import { getSchoolVacationCountryOptions, normalizeSchoolVacationCountry } from './schoolVacationCountries';
import { IFamilyMember } from '@app-types/websocket/family.types';
import {
  getDefaultSchoolVacationAccountIds,
  getSchoolVacationChildren,
  getSubmittedSchoolVacationAccountIds,
  schoolVacationChildrenKey,
  shouldKeepPreviousSchoolImportsByDefault,
} from './schoolVacationChildren';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  schoolName: string;
  schoolLocation: string;
  country:string;
  doNotClearPreviousSchoolImport:boolean;
  accountIds:number[];
}

interface IProps extends WithStyles<typeof HolidayStyle> {
  userId: number;
  close: () => void;
  familyData: { id: number, name: string, country: string, region: string };
  family: IFamilyMember[];
  aiTask: (task:IAiTask) => void;
  open:boolean;

  selectedCountry:string;
}

class AISchoolVacations extends React.Component<IProps, IState> {
  
  constructor(props: IProps) {
    super(props);
    
    this.state = {
      schoolName: "",
      schoolLocation: "",
      country:normalizeSchoolVacationCountry(props.selectedCountry),
      doNotClearPreviousSchoolImport:shouldKeepPreviousSchoolImportsByDefault(props.family),
      accountIds:getDefaultSchoolVacationAccountIds(props.family),
    };
  }

  public componentDidUpdate(previousProps: IProps) {
    if (schoolVacationChildrenKey(previousProps.family) !== schoolVacationChildrenKey(this.props.family)) {
      this.setState({
        accountIds:getDefaultSchoolVacationAccountIds(this.props.family),
        doNotClearPreviousSchoolImport:shouldKeepPreviousSchoolImportsByDefault(this.props.family),
      });
    }
  }

  public render() {
    const { classes, open} = this.props;
    const { schoolName, schoolLocation} = this.state;
    const children = getSchoolVacationChildren(this.props.family);
    const submittedAccountIds = getSubmittedSchoolVacationAccountIds(this.props.family, this.state.accountIds);

    return (

      <Dialog
        open={open}
        onClose={() => {this.props.close(); }}
      >
        <DialogTop>
          <DialogTitle>{""}</DialogTitle>
          <IconButton onClick={() => {this.props.close(); }}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <div style={{ padding: '8px 24px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ marginTop: '0px',}} className={classes.label}>{tn.lang.importSchool}</div>
          <input
            value={schoolName}
            maxLength={35}
            onChange={(event) => {
              this.setState({schoolName:event.target.value})
            }}
            className={classes.greyInput}
            placeholder={tn.lang.importSchoolExample}/>
          <div className={classes.label}>{tn.lang.importSchoolRegion}</div>
          <input
            value={schoolLocation}
            maxLength={35}
            onChange={(event) => {
              this.setState({schoolLocation:event.target.value})
            }}
            className={classes.greyInput}
            placeholder={tn.lang.importSchoolregionExample}/>
          <div className={classes.label}>{tn.lang.importSchoolCountry}</div>
          <select
            style={{ marginBottom: '24px',}} 
              value = {this.state.country}
              onChange = {(e) => this.setState({country:e.target.value})}
              className = {classes.greyInput}
          >
            {getSchoolVacationCountryOptions().map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
            
          </select>
          {children.length > 1 && <div role="group" aria-label={tn.lang.importSchoolChildren}>
            <div className={classes.label}>{tn.lang.importSchoolChildren}</div>
            <div style={{display:'flex', flexDirection:'column'}}>
              {children.map((child) => <FormControlLabel
                key={child.id}
                control={<Checkbox
                  color="primary"
                  checked={this.state.accountIds.includes(child.id)}
                  onChange={() => this.toggleAccountId(child.id)}
                />}
                label={child.firstName}
              />)}
            </div>
          </div>}
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={this.state.doNotClearPreviousSchoolImport}
                onChange={(event) => this.setState({doNotClearPreviousSchoolImport:event.target.checked})}
              />
            }
            label={tn.lang.doNotClearPreviousSchoolImport}
          />
        </div>
        
        <DialogActions>
          <Button
            variant="outlined"
            classes={{ outlined: classes.buttonOutlined }}
            onClick={() => {this.props.close(); }}
          >
            {tn.lang.cancel}
          </Button>
          <Button
            variant="contained"
            classes={{ contained: classes.buttonContained }}
            color="primary"
            onClick={() => this.searchSchoolVacationEvents()}
            disabled={schoolName.length < 2 || schoolLocation.length < 2 || submittedAccountIds.length === 0}
          >
            {tn.lang.import}
          </Button>
        </DialogActions>
      </Dialog>

    );
  }

  private searchSchoolVacationEvents = ()  => {

    const search:IAiTask = {
      language:tn.getLanguage()?tn.getLanguage():"EN",
      promptOne:this.state.schoolName,
      promptTwo:this.state.schoolLocation,
      promptThree:this.state.country,
      taskType:AI_TASK_TYPE.SCHOOL_VACATIONS,
      accountIds:getSubmittedSchoolVacationAccountIds(this.props.family, this.state.accountIds),
      ...(this.state.doNotClearPreviousSchoolImport ? {doNotClearPreviousSchoolImport:true} : {}),
    }

    this.props.aiTask(search)
    this.props.close();
  };

  private toggleAccountId = (accountId:number) => {
    this.setState((state) => ({
      accountIds:state.accountIds.includes(accountId)
        ? state.accountIds.filter((id) => id !== accountId)
        : [...state.accountIds, accountId],
    }));
  };

}




function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const familyData = state.family.familyData;
  const family = state.family.family;

  const language = navigator.language || navigator.languages[0];
  const parts = language.split(/[-_]/);
  const test =  parts.length > 1 ? parts[1].toLowerCase() : "us";

  const selectedCountry: string = (state.user.calendarSettings && state.user.calendarSettings.holidaysCountry)
    ? normalizeSchoolVacationCountry(state.user.calendarSettings.holidaysCountry)
    : normalizeSchoolVacationCountry(test);

  return {
    userId,
    familyData,
    family,
    selectedCountry
  };
}


const mapDispatchToProps = {
  aiTask: EventActions.aiTask,

};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(HolidayStyle)(AISchoolVacations));



// WEBPACK FOOTER //
// ./src/components/calendar2/holidays/AISchoolVacations.tsx